import React, { useEffect, useState, useRef } from "react";
import useChatStore from "../store/useChatStore";
import {
  createConversationAPI,
  getChatHistoryAPI,
} from "../api-services/conversation.api";
import ChatFooter from "../components/chat-window/ChatFooter";
import { createComplaintsAPI } from "../api-services/complaint.api";
import chatbotIcon from "../assets/images/chatbot.png";

const ChatPage = () => {
  const [chats, setChats] = useState([]);
  const [conversationUuid, setConversationUuid] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const chatEndRef = useRef(null);
  const { createdOrderInfo, chatbotTheme } = useChatStore();

  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;

  const fetchConversationHistory = () => {
    try {
      getChatHistoryAPI({ customerUuid: createdOrderInfo.customerUuid }).then(
        (historyResp) => {
          if (historyResp.payload.result?.length > 0) {
            setConversationUuid(historyResp.payload.conversationUuid);
            setChats(historyResp.payload.result.slice(0, -1));
            setTimeout(() => {
              setChats(historyResp.payload.result);
            }, [2000]);
          }
        }
      );
    } catch {}
  };

  const checkIsComplaint = () => {
    if (chats?.length > 0) {
      if (
        chats[chats.length - 1].senderType === "System" &&
        chats[chats.length - 1].messageType === "Complaint"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleConversation = (messagetype, payload) => {
    const conversationPayload = {
      shopId: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
      conversationUuid: conversationUuid !== "" ? conversationUuid : null,
      customerUuid: createdOrderInfo.customerUuid,
      messageType: messagetype,
      payload: payload,
    };
    createConversationAPI(conversationPayload).then((conversationResp) => {
      if (conversationResp.status === 201) {
        fetchConversationHistory();
      }
    });
  };

  const handleSendMessage = (text) => {
    setLoading(true);
    const complaintPayload = {
      orderUuid: createdOrderInfo.uuid,
      companyUuid: createdOrderInfo.accountUuid,
      productUuid: createdOrderInfo.productUuid,
      title: text,
      description: null,
      ticketId: null,
      customerUuid: createdOrderInfo.customerUuid,
      location: null,
      departmentUuid: null,
    };
    createComplaintsAPI(complaintPayload)
      .then((res) => {
        if (res.status === 201) {
          setLoading(false);
          setMessage("");
          const compaintRes = res.json();
          compaintRes.then((complaitInfo) => {
            handleConversation("complaint", {
              complaint: text,
              complaintID: complaitInfo.payload.complaint.ticketId,
            });
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chats]);

  useEffect(() => {
    fetchConversationHistory();
  }, []);

  return (
    <>
      <div
        className="chat-box-container"
        style={{ display: "flex", flexDirection: "column-reverse" }}
      >
        <div className="chat-body-container">
          {chats.map((msg, index) => {
            return (
              <div key={index} className="chat-box-customer">
                {msg.senderType === "Customer" ? (
                  <>
                    {msg.messageType === "Card" && (
                      <div className="chat-box-cardlayout">
                        <div
                          className="chat-box-card"
                          style={{ backgroundColor: chatbotTheme }}
                        >
                          <img src={msg.message.productImage} alt="Product" />
                          <label className="product-name">
                            {msg.message.productName}
                          </label>
                          <label>Qty: {msg.message.productQuantity}</label>
                          <label>Price: {msg.message.productPrice}</label>
                        </div>
                      </div>
                    )}
                    {msg.messageType === "Complaint" && (
                      <div
                        className="customer-issue"
                        style={{ backgroundColor: chatbotTheme }}
                      >
                        {msg.message?.result}
                      </div>
                    )}
                    {msg.messageType === "Text" && (
                      <div
                        className="customer-issue"
                        style={{ backgroundColor: chatbotTheme }}
                      >
                        {msg.message.result}
                      </div>
                    )}
                    <label className="product-card-time">
                      {new Date(msg.createdAt).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </label>
                  </>
                ) : (
                  <>
                    {msg.messageType === "Options" && (
                      <>
                        <div className="chat-box-option-container">
                          <div
                            className="chatbot-bg"
                            style={{ backgroundColor: chatbotTheme }}
                          >
                            <img
                              src={chatbotIcon}
                              alt="Chatbot"
                              className="chatbot-icon-chat"
                            />
                          </div>

                          <div
                            style={{ position: "relative", maxWidth: "80%" }}
                          >
                            <div className="chat-box-option">
                              Select the option
                            </div>
                            <span className="chat-box-option-time">
                              {new Date(msg.createdAt).toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="auto-chat-option">
                          {Object.values(msg.message).map((opt, optIdx) => (
                            <label
                              key={optIdx}
                              style={{ border: `1px solid ${chatbotTheme}` }}
                              onClick={() =>
                                handleConversation("options", {
                                  inputOption: opt,
                                  orderUuid: createdOrderInfo.uuid,
                                })
                              }
                            >
                              {opt}
                            </label>
                          ))}
                        </div>
                      </>
                    )}
                    {(msg.messageType === "Text" ||
                      msg.messageType === "Complaint") && (
                      <div className="chat-box-text-container">
                        <div
                          className="chatbot-bg"
                          style={{ backgroundColor: chatbotTheme }}
                        >
                          <img
                            src={chatbotIcon}
                            alt="Chatbot"
                            className="chatbot-icon"
                          />
                        </div>
                        <div style={{ position: "relative", maxWidth: "80%" }}>
                          <div className="chat-box-text">
                            {msg.message.result}
                          </div>
                          <span className="chat-box-text-time">
                            {new Date(msg.createdAt).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                    {msg.messageType === "OrderInfo" && (
                      <div className="chat-box-option-container">
                        <div
                          className="chatbot-bg"
                          style={{ backgroundColor: chatbotTheme }}
                        >
                          <img
                            src={chatbotIcon}
                            alt="Chatbot"
                            className="chatbot-icon-chat"
                          />
                        </div>
                        <div style={{ position: "relative", maxWidth: "80%" }}>
                          <div
                            className="chat-box-option"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 3,
                            }}
                          >
                            <label>
                              OrderId: {msg.message.result?.orderId}
                            </label>
                            <label>
                              Expiry Date:{" "}
                              {msg.message.result?.productWarrantyExpiry &&
                                new Date(
                                  msg.message.result?.productWarrantyExpiry
                                ).toLocaleDateString()}
                            </label>
                            <label>
                              Purchased Date:{" "}
                              {msg.message.result?.purchaseDate &&
                                new Date(
                                  msg.message.result?.purchaseDate
                                ).toLocaleDateString()}
                            </label>
                          </div>
                          <span className="chat-box-option-time">
                            {new Date(msg.createdAt).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}
          <div ref={chatEndRef} />
        </div>
      </div>
      {checkIsComplaint() && (
        <ChatFooter
          handleChatMessage={handleSendMessage}
          message={message}
          setMessage={setMessage}
          loading={loading}
        />
      )}
    </>
  );
};

export default ChatPage;
